import * as React from "react";
import type { SVGProps } from "react";
const SvgRouteplanner = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.874-1A4.002 4.002 0 0 0 3 6a4 4 0 0 0 7.874 1h4.876a2.25 2.25 0 0 1 .87 4.326 2 2 0 0 0-3.352.174H8.25a4.25 4.25 0 0 0-3.628 2.036 2 2 0 0 0-.297 3.847A4.25 4.25 0 0 0 8.25 20H13v-2H8.25a2.25 2.25 0 0 1-1.892-1.032C6.753 16.603 7 16.08 7 15.5c0-.47-.162-.902-.433-1.243A2.24 2.24 0 0 1 8.25 13.5h5.018a2 2 0 0 0 3.534-.131A4.252 4.252 0 0 0 15.75 5zM18 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgRouteplanner;
